$(document).ready(function() {
    return;
    var $window = $(window);		//Window object
    var scrollTime = 0.4;			//Scroll time
    var scrollDistance = 400;		//Distance. Use smaller value for shorter scroll and greater value for longer scroll
    var smallScrollDistance = 200;

    mobile_ie = -1 !== navigator.userAgent.indexOf("IEMobile");

    if(!$('html').hasClass('touch') && !mobile_ie) {
        $window.on("mousewheel DOMMouseScroll", function(event) {
            // Window event should be prevented in both cases(if modal exists too)
            event.preventDefault();

            // Fix for modal form double scroll
            if($("body").find("> .modalForm").length > 0 &&
               $("body").find("> .modalForm").hasClass("visible"))
                return;

            var delta = event.originalEvent.wheelDelta / 120 || -event.originalEvent.detail / 3;
            var scrollTop = $window.scrollTop();
            var finalScroll = scrollTop - parseInt(delta * scrollDistance);

            TweenLite.to($window, scrollTime, {
                scrollTo: {
                    y: finalScroll, autoKill: !0
                },
                ease: Power1.easeOut,
                autoKill: !0,
                overwrite: 5
            });

        });

        $("body").on("mousewheel DOMMouseScroll", "> .modalForm form", function(event) {
            event.preventDefault();

            var $form = $("body").find("> .modalForm form");
            var delta = event.originalEvent.wheelDelta / 120 || -event.originalEvent.detail / 3;
            var scrollTop = $form.scrollTop();
            var finalScroll = scrollTop - parseInt(delta * smallScrollDistance);

            TweenLite.to($form, scrollTime, {
                scrollTo: {
                    y: finalScroll, autoKill: !0
                },
                ease: Power1.easeOut,
                autoKill: !0,
                overwrite: 5
            });
        });
    }
});
